import { render, staticRenderFns } from "./update_mobile.vue?vue&type=template&id=5cdeec50&scoped=true"
import script from "./update_mobile.vue?vue&type=script&lang=js"
export * from "./update_mobile.vue?vue&type=script&lang=js"
import style0 from "./update_mobile.vue?vue&type=style&index=0&id=5cdeec50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdeec50",
  null
  
)

export default component.exports